import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CardContent, Divider, Theme } from '@mui/material'

import { UserHeaderBackButton, UserHeaderInfo, UserHeaderLoading } from './components'
import { useUserDetailsViewStore } from './UserDetailsView.store'

export type CorporateDetailsViewHeaderProps = ExtendableStyles & Testable

export function UserDetailsViewHeader({ className, style, ...otherProps }: CorporateDetailsViewHeaderProps) {
  const { classes } = useStyles()
  const {
    state: { user, status },
  } = useUserDetailsViewStore()
  const isLoading = status === 'loading' && !user
  return (
    <CardContent component="header" className={classNames(className, classes.container)} {...otherProps}>
      <UserHeaderBackButton className={classes.backButton} />
      <Divider className={classes.divider} orientation="vertical" flexItem />
      {isLoading ? (
        <UserHeaderLoading className={classes.headerContent} />
      ) : (
        <UserHeaderInfo className={classes.headerContent} user={user!} />
      )}
    </CardContent>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: spacing(),
  },
  backButton: {
    flex: '0 0 auto',
  },
  divider: {
    margin: spacing(0, 2),
  },
  headerContent: {
    flex: '1 1 auto',
  },
}))
